import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reportFill" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpeg, jpg, png 格式，不超过20m", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpeg, jpg, png 格式，不超过20m", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 mp3, mkv, wma 格式，不超过50m", -1)

import { basicFormConfig } from "./config/form.config";
import { useUpload } from "@/hooks/useUpload";
import { reactive, ref } from "vue";
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Fill',
  setup(__props) {

const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed,
  filesMap, proveFiles, records] = useUpload()
const fileList = ref<any[]>([])
const route = useRoute()
const defaultInfo = ref({})
defaultInfo.value = route.query
defaultInfo.value.isCreate = true
const otherInfo = reactive({
  proofImgUrls: '',
  recordingUrls: '',
  proveImgUrls: '',
})
const handleValid = () => {
  otherInfo.proofImgUrls = ''
  otherInfo.recordingUrls = ''
  otherInfo.proveImgUrls = ''

  filesMap.value.forEach((value: string, key: string) => {
    otherInfo.proofImgUrls = otherInfo.proofImgUrls + value + ','
  })
  otherInfo.proofImgUrls = otherInfo.proofImgUrls.slice(0, -1);
  console.log(otherInfo.proofImgUrls)

  proveFiles.value.forEach((value: string, key: string) => {
    otherInfo.proveImgUrls = otherInfo.proveImgUrls + value + ','
  })
  otherInfo.proveImgUrls = otherInfo.proveImgUrls.slice(0, -1)
  console.log(otherInfo.proveImgUrls)

  if (records.value.length > 0) {
    otherInfo.recordingUrls = records.value[0]
  }
  return true
}
const handleImgRemove = (uploadFile: any, uploadFiles: any) => {
  filesMap.value.delete(String(uploadFile.uid))
}

const handleProveImageRemove = (uploadFile: any, uploadFiles: any) => {
  proveFiles.value.delete(String(uploadFile.uid))
}

let dialogImageUrl = ref()
const dialogVisible = ref(false)
const handlePreview = (file: any) => {
  dialogImageUrl.value = file.url
  dialogVisible.value = true
}


const handleRecordRemove = (uploadFile: any, uploadFiles: any) => {
  records.value.splice(0, records.value.length)
}

const closePage = () => {
  window.close()
}


return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BasicForm = _resolveComponent("BasicForm")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BasicForm, {
        basicFormConfig: _unref(basicFormConfig),
        pageName: "newFundsVerification",
        defaultInfo: defaultInfo.value,
        otherInfo: otherInfo,
        validOtherInfo: handleValid,
        onClosePage: closePage
      }, {
        insert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": fileList.value,
            "before-upload": _unref(beforeUpload),
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            accept: ".jpeg,.jpg,.png",
            "on-remove": handleImgRemove,
            multiple: "",
            "list-type": "picture-card",
            "on-preview": handlePreview
          }, {
            tip: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
        ]),
        proveInsert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": fileList.value,
            "before-upload": _unref(proveUpload),
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            accept: ".jpeg,.jpg,.png",
            "on-remove": handleProveImageRemove,
            multiple: "",
            "list-type": "picture-card",
            "on-preview": handlePreview
          }, {
            tip: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
        ]),
        fileInsert: _withCtx(() => [
          _createVNode(_component_el_upload, {
            action: _unref(action),
            data: _unref(extraData),
            accept: ".mp3, .mkv, .wma",
            "on-remove": handleRecordRemove,
            "show-file-list": true,
            limit: 1,
            "auto-upload": true,
            "before-upload": _unref(beforeUpload),
            ref: "recordUpload"
          }, {
            tip: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("选择文件")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["action", "data", "before-upload"])
        ]),
        _: 1
      }, 8, ["basicFormConfig", "defaultInfo", "otherInfo"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "图片预览",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      width: "50%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_image, {
          src: _unref(dialogImageUrl),
          fit: "fit",
          lazy: ""
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})